<template>
  <div class="container relative flex flex-col h-screen mx-auto">
    <div
      ref="navbar"
      class="relative top-0 left-0 right-0 z-10 flex-none learn-header"
      :style="[navbarHeight ? { height: navbarHeight + 'px' } : { height: '7%' }]"
    >
      <NavBar>
        <template slot="prev">
          <button
            v-if="GET_ACTIVE_SCENE_INDEX > 0 && GET_PLAY_STATUS === 1"
            class="block w-full py-2 font-bold text-center text-white sm:text-xl button v:py-4 sm:py-3"
            @click="prevScene"
          >
            이전으로
          </button>
          <button
            v-else
            class="block w-full py-2 font-bold text-center text-white sm:text-xl button v:py-4 sm:py-3"
            @click="prev"
          >
            이전으로
          </button>
        </template>
      </NavBar>
      <!--end::NavBar-->
    </div>

    <div
      :style="{ maxHeight: contentHeight + 'px' }"
      class="relative flex-1 border-0 border-l-2 border-r-2 learn-content overflow-hidden"
    >
      <slot />
      <!--end::slot-->
    </div>

    <div
      ref="statusbar"
      :style="[statusbarHeight ? { height: statusbarHeight + 'px' } : { height: '20%' }]"
      class="relative bottom-0 z-10 flex-none learn-footer"
    >
      <StatusBar />
      <!--end::StatusBar-->
    </div>
  </div>
</template>

<script>
import NavBar from '@components/game/nav-bar.vue'
import { LAYOUTS } from '@state/modules/layout'
import { EVENT } from '@src/games/constant'
import { mapGetters } from 'vuex'
import { PLAYS } from '@state/modules/play'
import StatusBar from '@components/game/status-bar.vue'

export default {
  name: 'LearnLayout',
  components: { StatusBar, NavBar },
  data() {
    return {
      navbarHeight: null,
      contentHeight: 0,
      statusbarHeight: null,
    }
  },
  computed: {
    ...mapGetters(LAYOUTS.NAME, [LAYOUTS.GET_IS_VERTICAL_SCREEN]),
    ...mapGetters(PLAYS.NAME, [PLAYS.GET_ACTIVE_SCENE_INDEX, PLAYS.GET_PLAY_STATUS]),
  },
  mounted() {
    this.ready()
  },
  methods: {
    ready() {
      const screenHeight = window.innerHeight
      this.navbarHeight = this.$refs.navbar.clientHeight
      this.statusbarHeight = this.$refs.statusbar.clientHeight
      this.contentHeight = screenHeight - (this.navbarHeight + this.statusbarHeight)

      this.$log.debug(
        'navbar height : ',
        this.navbarHeight,
        'statusbar height : ',
        this.statusbarHeight,
        'content height : ',
        this.contentHeight
      )

      this.$store.commit(LAYOUTS.NAMESPACE(LAYOUTS.SET_LAYOUT_DIMENSION), {
        navbarHeight: this.navbarHeight,
        contentHeight: this.contentHeight,
        statusbarHeight: this.statusbarHeight,
      })
    },
    prevScene() {
      if (this.GET_ACTIVE_SCENE_INDEX > 0) {
        this.$events.emit(EVENT.PLAY_SCENE_PREV)
      }
    },
    prev() {
      if (this.GET_ACTIVE_SCENE_INDEX < 0) {
        this.$events.emit(EVENT.PLAY_SCENE_PREV)
      } else {
        window.history.back()
      }
    },
  },
}
</script>

<style scoped>
.learn-content {
  border-color: var(--color-bg);
}
</style>
